window.groupReportVersions = function() {
  var uniqueForms = [];
  $("[data-form-instance]").each(function() {
    var form_instance = $(this).attr("data-form-instance");
    if ($.inArray(form_instance, uniqueForms) === -1) {
      uniqueForms.push(form_instance);
    }
  });
  
  $.each(uniqueForms, function(index, value) {
    $("[data-form-instance='" + value + "']:not(:first)").find('.js-version-header').remove();
  });


}